import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import type { OrderPersonalFormValues } from '@innogy/become-a-customer/state';
import {
  CommonUiFormsModule,
  PhoneComponent,
  RadioItem,
} from '@innogy/common-ui/forms';
import {
  CommonUiProgressiveFormsModule,
  SimpleProgressiveFormsConfigService,
} from '@innogy/common-ui/progressive-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import type { InitialsConverter } from '@innogy/utils-deprecated';
import {
  initialsConverter,
  normalizeDateString,
  IsInvalidPipe,
  AutocompleteDirective,
} from '@innogy/utils-deprecated';
import { InfoCardComponent } from '@legacy/common-ui-utility-components';

import { OrderFulfillmentStepComponent } from '../order-fulfillment-step.component';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

@Component({
  selector: 'wl-order-fulfillment-personal[progressiveFormState]',
  templateUrl: './order-fulfillment-personal.component.html',
  styleUrls: ['./order-fulfillment-personal.component.ed.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    PhoneComponent,
    CommonUiFormsModule,
    CommonUiProgressiveFormsModule,
    AutomationIdDirective,
    AutocompleteDirective,
    IsInvalidPipe,
    InfoCardComponent,
    CSMaskDirective,
  ],
  providers: [SimpleProgressiveFormsConfigService],
})
export class OrderFulfillmentPersonalComponent extends OrderFulfillmentStepComponent<OrderPersonalFormValues> {
  _initialsConverter?: InitialsConverter = initialsConverter();

  readonly labelsShownAboveFields = input(false);
  readonly genderOptions = input.required<RadioItem[]>();

  override readonly progressiveFormCardContent = computed(() => ({
    title: this.orderContent().personalCardTitle.value ?? '',
    subtitle: this.orderContent().personalCardSubTitle,
    submitButtonText: this.orderContent().personalCardSubmitButton,
    stepNumber: this.stepNumber(),
  }));

  readonly givenDateOfBirth = computed(() =>
    normalizeDateString(this.formState().controls.dateOfBirth.value)
  );
  readonly emailFieldValuesMatch = computed(
    () =>
      this.formState().value.email === this.formState().value.emailValidation
  );
}
